import { VenueReservation } from "@/graphql/operations";
import { gql } from "@apollo/client";

export type GetVenueReservationsRangeQueryInput = {
  venuePortalUserId: string;
  gracePeriodMs?: number;
  range: {
    from: Date;
    until: Date;
  };
  venueId?: string;
  productId?: string;
};
export type GetVenueReservationsRangeQueryResponse = {
  venuePortalUser: {
    id: string;
    pendingReservationsCount: number;
    pendingReservations: VenueReservation[];

    reservations: {
      venueReservations: VenueReservation[];
    };
  } | null;
};

export const reservationFields = gql`
  fragment ReservationFields on VenueReservation {
    additionalInfo
    additionalInfoSetAt
    answer
    answeredBy
    created
    groupVenueId
    id
    numGuests
    numGuides
    reservationAnswerReceived
    reservationTime

    cancellation {
      id
      created
      reason
    }

    cancellationCosts {
      id
      quantity
      chargedCost
    }

    costs {
      id
      quantity
      cost
      isNoShow
    }

    latestInquiry {
      body
    }

    group {
      id
      date
      time
      type

      groupedGuests(includeRoles: ["OJT Trainee"]) {
        name
        quantity
      }

      bookings {
        id
        details {
          id
          quantity

          productPrice {
            id
            name
          }
        }
      }

      guides(excludeRoles: ["OJT Trainee"]) {
        id
        name
        phoneNumber
        profilePic
      }

      guideAssignments {
        role

        guide {
          id
          name
          phoneNumber
          profilePic
        }
      }

      product {
        id
        name
      }
    }

    venue {
      id
      name
    }

    venuePortalUser {
      id
    }

    originalReservation {
      id
      answer
      numGuests
      numGuides
      reservationAnswerReceived

      snapshot {
        groupedGuests(includeRoles: ["OJT Trainee"]) {
          name
          quantity
        }

        details {
          id
          quantity

          productPrice {
            id
            name
          }
        }

        guide {
          id
          name
          phoneNumber
          profilePic
        }
      }
    }
  }
`;

export const GET_VENUE_RESERVATIONS_RANGE_QUERY = gql`
  ${reservationFields}

  query GetVenuePortalUserVenueReservationsRange(
    $venuePortalUserId: ID!
    $gracePeriodMs: Int
    $range: DateRange!
    $venueId: ID
    $productId: ID
  ) {
    venuePortalUser(id: $venuePortalUserId) {
      id
      pendingReservationsCount(
        gracePeriodMs: $gracePeriodMs
        venueId: $venueId
        productId: $productId
      )

      pendingReservations(
        gracePeriodMs: $gracePeriodMs
        venueId: $venueId
        productId: $productId
      ) {
        ...ReservationFields
      }

      reservations(range: $range, venueId: $venueId, productId: $productId) {
        venueReservations {
          ...ReservationFields
        }
      }
    }
  }
`;

export const GET_VENUE_RESERVATIONS_QUERY = GET_VENUE_RESERVATIONS_RANGE_QUERY;
export type GetVenueReservationsQueryInput =
  GetVenueReservationsRangeQueryInput;
export type GetVenueReservationsQueryResponse =
  GetVenueReservationsRangeQueryResponse;
